@if (isOpen()) {
  <div class="modal-backdrop" animate.enter="backdrop-enter" animate.leave="backdrop-leave" (click)="onBackdropClick()">
    <div class="glass-overlay"></div>
  </div>

  <div class="modal-container" animate.enter="modal-enter" animate.leave="modal-leave"
    (click)="$event.stopPropagation()">
    <app-mat3-button
      variant="icon"
      icon="solar:close-circle-bold"
      [iconSize]="20"
      class="modal-close"
      ariaLabel="Close modal"
      (buttonClick)="onClose()"
    />

    <div class="modal-content" #modalContent>
      <div class="clouds-container">
        <div class="cloud cloud-1"></div>
        <div class="cloud cloud-2"></div>
      </div>

      <img src="/assets/images/illustrations/path-background.svg" alt="" class="path-svg" />

      <div class="content-inner">
        <div class="hero-row">
          <div class="hero-left">
            <h1 class="hero-title">{{ 'onboarding.welcomeTitle' | translate }}</h1>
            <p class="hero-subtitle">{{ 'onboarding.welcomeSubtitle' | translate }}</p>
            <div class="new-farm-info">
              <app-icon [icon]="'solar:info-circle-bold'" [color]="'#3b82f6'" [size]="20"></app-icon>
              <span>{{ 'onboarding.newFarmInfoStart' | translate }} <strong>{{ farmStore.currentFarmName() }}</strong>
                {{ 'onboarding.newFarmInfoEnd' | translate }}</span>
            </div>
          </div>

          <div class="hero-right">
            <div class="farmer-ai-assistant">
              <div class="robot-wrapper">
                <div class="robot-container" (click)="onRobotClick()">
                  <div class="robot-float">
                    <app-lottie-player src="/assets/images/animated/farmer.lottie" [width]="128" [height]="128"
                      [autoplay]="true" [loop]="true">
                    </app-lottie-player>
                  </div>
                </div>
              </div>

              <div class="connector-svg-wrapper">
                <img src="/assets/images/illustrations/connector-paths.svg" alt="" />
              </div>

              <div class="steps-row">
                <app-adaptive-popover [preferredPosition]="'top'" [showDelay]="100" [hideDelay]="150"
                  panelClass="onboarding-popover">
                  <div class="step-trigger" (click)="onStepClick(1)">
                    <div class="step-number step-1">1</div>
                    <p class="step-label">{{ 'onboarding.step1Title' | translate }}</p>
                  </div>
                  <ng-template appPopoverContent>
                    <strong class="popover-title green">{{ 'onboarding.step1PopoverTitle' | translate }}</strong>
                    <div class="popover-illustration">
                      <img src="/assets/images/illustrations/step1-field-polygon.svg" alt="" />
                    </div>
                    <span class="popover-desc">{{ 'onboarding.step1PopoverDesc' | translate }}</span>
                  </ng-template>
                </app-adaptive-popover>

                <app-adaptive-popover [preferredPosition]="'top'" [showDelay]="100" [hideDelay]="150"
                  panelClass="onboarding-popover">
                  <div class="step-trigger" (click)="onStepClick(2)">
                    <div class="step-number step-2">2</div>
                    <p class="step-label">{{ 'onboarding.step2Title' | translate }}</p>
                  </div>
                  <ng-template appPopoverContent>
                    <strong class="popover-title amber">{{ 'onboarding.step2PopoverTitle' | translate }}</strong>
                    <div class="popover-illustration">
                      <img src="/assets/images/illustrations/step2-barn.svg" alt="" width="60" height="60" />
                    </div>
                    <span class="popover-desc">{{ 'onboarding.step2PopoverDesc' | translate }}</span>
                  </ng-template>
                </app-adaptive-popover>

                <app-adaptive-popover [preferredPosition]="'top'" [showDelay]="100" [hideDelay]="150"
                  panelClass="onboarding-popover">
                  <div class="step-trigger">
                    <div class="step-number step-3">3</div>
                    <p class="step-label">{{ 'onboarding.step3Title' | translate }}</p>
                  </div>
                  <ng-template appPopoverContent>
                    <strong class="popover-title blue">{{ 'onboarding.step3PopoverTitle' | translate }}</strong>
                    <div class="popover-illustration">
                      <img src="/assets/images/illustrations/step3-calendar.svg" alt="" width="32" height="32" />
                    </div>
                    <span class="popover-desc">{{ 'onboarding.step3PopoverDisabledDesc' | translate }}</span>
                  </ng-template>
                </app-adaptive-popover>
              </div>
            </div>
          </div>
        </div>

        <div class="tiles-grid">
          <div class="tile">
            <div class="tile-illustration field-mapping">
              <div class="grid-overlay"></div>
              <img src="/assets/images/illustrations/field-mapping-polygon.svg" alt="" class="field-polygon" />
              <div class="area-label"><span>Area: 24.50 ac</span></div>
            </div>
            <h3 class="tile-title">{{ 'onboarding.tiles.fieldMapping.title' | translate }}</h3>
            <p class="tile-description">{{ 'onboarding.tiles.fieldMapping.description' | translate }}</p>
            <button class="tile-action-btn" (click)="navigateToFields()">
              {{ 'onboarding.tiles.fieldMapping.action' | translate }}
              <app-icon [icon]="'solar:arrow-right-linear'" [color]="'currentColor'"></app-icon>
            </button>
          </div>

          <div class="tile">
            <div class="tile-illustration livestock">
              <img src="/assets/images/illustrations/farm-cattle.svg" alt="" class="livestock-bg" />
              <div class="health-badge"><span>Health 98%</span></div>
            </div>
            <h3 class="tile-title">{{ 'onboarding.tiles.livestock.title' | translate }}</h3>
            <p class="tile-description">{{ 'onboarding.tiles.livestock.description' | translate }}</p>
            <button class="tile-action-btn" (click)="navigateToLivestock()">
              {{ 'onboarding.tiles.livestock.action' | translate }}
              <app-icon [icon]="'solar:arrow-right-linear'" [color]="'currentColor'"></app-icon>
            </button>
          </div>

          <div class="tile">
            <div class="tile-illustration crops">
              <div class="crops-container">
                <div class="crop-stem crop-1">
                  <div class="stem-fill"></div>
                  <div class="soil-line"></div>
                </div>
                <div class="crop-stem crop-2">
                  <div class="stem-fill"></div>
                  <div class="soil-line"></div>
                </div>
                <div class="crop-stem crop-3">
                  <app-icon [icon]="'lucide:sprout'" [color]="'#16a34a'" [customClass]="'sprout-icon'"></app-icon>
                  <div class="stem-fill"></div>
                  <div class="soil-line"></div>
                </div>
              </div>
              <div class="sun-icon">
                <div class="sun-glow"></div>
                <div class="sun-core"></div>
              </div>
            </div>
            <h3 class="tile-title">{{ 'onboarding.tiles.crops.title' | translate }}</h3>
            <p class="tile-description">{{ 'onboarding.tiles.crops.description' | translate }}</p>
            <button class="tile-action-btn" (click)="openCropsActionPanel()">
              {{ 'onboarding.tiles.crops.action' | translate }}
              <app-icon [icon]="'solar:arrow-right-linear'" [color]="'currentColor'"></app-icon>
            </button>
          </div>

          <div class="tile">
            <div class="tile-illustration equipment">
              <div class="fleet-header">
                <span class="fleet-label">FLEET STATUS</span>
                <div class="status-dots"><span class="status-dot"></span><span class="status-dot"></span></div>
              </div>
              <div class="progress-bar-container">
                <div class="progress-bar-fill"></div>
              </div>
              <div class="fleet-footer">
                <app-icon [icon]="'lucide:tractor'" [color]="'#2563eb'" [customClass]="'tractor-icon'"></app-icon>
                <span class="active-count">2 Active</span>
              </div>
            </div>
            <h3 class="tile-title">{{ 'onboarding.tiles.equipment.title' | translate }}</h3>
            <p class="tile-description">{{ 'onboarding.tiles.equipment.description' | translate }}</p>
            <button class="tile-action-btn" (click)="openEquipmentActionPanel()">
              {{ 'onboarding.tiles.equipment.action' | translate }}
              <app-icon [icon]="'solar:arrow-right-linear'" [color]="'currentColor'"></app-icon>
            </button>
          </div>

          <div class="tile">
            <div class="tile-illustration tasks">
              <div class="task-list">
                <div class="task-item">
                  <div class="checkbox checked"><span class="checkmark"></span></div>
                  <div class="task-bar"></div>
                </div>
                <div class="task-item">
                  <div class="checkbox"><span class="checkmark"></span></div>
                  <div class="task-bar short"></div>
                </div>
                <div class="task-item">
                  <div class="checkbox"><span class="checkmark"></span></div>
                  <div class="task-bar long"></div>
                </div>
              </div>
              <app-icon [icon]="'lucide:clipboard-check'" [color]="'#c4b5fd'"
                [customClass]="'clipboard-icon'"></app-icon>
            </div>
            <h3 class="tile-title">{{ 'onboarding.tiles.tasks.title' | translate }}</h3>
            <p class="tile-description">{{ 'onboarding.tiles.tasks.description' | translate }}</p>
            <button class="tile-action-btn" (click)="openTasksActionPanel()">
              {{ 'onboarding.tiles.tasks.action' | translate }}
              <app-icon [icon]="'solar:arrow-right-linear'" [color]="'currentColor'"></app-icon>
            </button>
          </div>

          <div class="tile">
            <div class="tile-illustration buildings">
              <div class="buildings-container">
                <div class="silo"><span class="silo-label">SILO A</span>
                  <div class="silo-fill"></div>
                </div>
                <div class="warehouse">
                  <app-icon [icon]="'lucide:warehouse'" [color]="'#94a3b8'" [customClass]="'warehouse-icon'"></app-icon>
                </div>
              </div>
            </div>
            <h3 class="tile-title">{{ 'onboarding.tiles.buildings.title' | translate }}</h3>
            <p class="tile-description">{{ 'onboarding.tiles.buildings.description' | translate }}</p>
            <button class="tile-action-btn" (click)="openBuildingsActionPanel()">
              {{ 'onboarding.tiles.buildings.action' | translate }}
              <app-icon [icon]="'solar:arrow-right-linear'" [color]="'currentColor'"></app-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-aviator-action-panel [actions]="step1Actions" [title]="'onboarding.step1QuickActionTitle'"
    [isOpen]="isStep1ActionPanelOpen()" (closePanel)="closeStep1ActionPanel()">
  </app-aviator-action-panel>

  <app-aviator-action-panel [actions]="step2Actions" [title]="'onboarding.step2QuickActionTitle'"
    [isOpen]="isStep2ActionPanelOpen()" (closePanel)="closeStep2ActionPanel()">
  </app-aviator-action-panel>

  <app-aviator-action-panel [actions]="cropsActions" [title]="'onboarding.cropsQuickActionTitle'"
    [isOpen]="isCropsActionPanelOpen()" (closePanel)="closeCropsActionPanel()">
  </app-aviator-action-panel>

  <app-aviator-action-panel [actions]="equipmentActions" [title]="'onboarding.equipmentQuickActionTitle'"
    [isOpen]="isEquipmentActionPanelOpen()" (closePanel)="closeEquipmentActionPanel()">
  </app-aviator-action-panel>

  <app-aviator-action-panel [actions]="tasksActions" [title]="'onboarding.tasksQuickActionTitle'"
    [isOpen]="isTasksActionPanelOpen()" (closePanel)="closeTasksActionPanel()">
  </app-aviator-action-panel>

  <app-aviator-action-panel [actions]="buildingsActions" [title]="'onboarding.buildingsQuickActionTitle'"
    [isOpen]="isBuildingsActionPanelOpen()" (closePanel)="closeBuildingsActionPanel()">
  </app-aviator-action-panel>
}